import "./Header.css";

import React from "react";
import { getRandomColor } from "../../helper";
import { selectUser } from "../../redux/reducers/userReducer";
import { useSelector } from "react-redux";

const ProfileMenu = ({
  forwardRef,
  handleAdminConsole,
  handleCustomerConsole,
  handleLogout,
  handleCancelSucription,
}) => {
  const user = useSelector(selectUser);

  const userName = user.data?.user.name || "";
  const userEmail = user.data?.user.user_id || "";
  const firstLetter = userName.charAt(0).toUpperCase();

  const avatarColor = getRandomColor(firstLetter);
  const profileImage = user.data?.user?.profileImage;

  const isAdmin = user.data?.user?.userType === "admin";
  const isWriter = user.data?.user?.userType === "writer";
  const isCustomer = user.data?.user?.userType === "customer";
  const isSubscribedUser = !!user?.data?.subscriptionPlan;

  const menu: any[] = [];

  if (isAdmin) {
    menu.push(
      {
        title: "Admin Console",
        icon: "./assets/adminConsole.svg",
        onClick: handleAdminConsole,
      },
      {
        title: "Customer Console",
        icon: "./assets/adminConsole.svg",
        onClick: handleCustomerConsole,
      }
    );
  } else if (isCustomer) {
    menu.push({
      title: "Customer Console",
      icon: "./assets/adminConsole.svg",
      onClick: handleCustomerConsole,
    });
  } else if (isWriter) {
    menu.push({
      title: "Admin Console",
      icon: "./assets/adminConsole.svg",
      onClick: handleAdminConsole,
    });
  }

  if (isSubscribedUser) {
    menu.push({
      title: "Cancel Subcription",
      icon: "./assets/adminConsole.svg",
      onClick: handleCancelSucription,
    });
  }

  menu.push({
    title: "Logout",
    icon: "./assets/Logout.svg",
    onClick: handleLogout,
  });

  return (
    <div ref={forwardRef}>
      <div className="profile-menu">
        <span className="profile-information">
          <span className="profile-avatar-name">
            {profileImage ? (
              <img
                src={profileImage}
                alt="Profile"
                className="profile-icon-small"
              />
            ) : (
              <span
                className="profile-icon-small"
                style={{
                  backgroundColor: avatarColor,
                }}
              >
                {firstLetter}
              </span>
            )}
            <div>
              <span className="profile-name">{userName}</span>
              <div className="profile-email">{userEmail}</div>
            </div>
          </span>
        </span>

        <hr className="profile-separator" />

        {menu.map((item, index) => {
          return (
            <div key={item.title} className="profile-menu-adminconsoleitem">
              <img
                src={item.icon}
                alt="adminconsoleimg"
                style={{ margin: 0, alignSelf: "center" }}
              />
              <button onClick={item.onClick}>{item.title}</button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProfileMenu;
